<template lang="pug">
#challenge-reports.box.p-2
  WtTile(parent :col="12").complete-report
    WtTile(parent :col="12").no-padding.reportTile
      WtTile(child :col="6").no-padding
        WtTitle(h5).mb-5 Challenge Completion Report
        //- TODO  and badges won.
        small A summary of complete challenges by member.
      WtTile(child :col="6").no-padding
        WtTile(parent :col="12").no-padding

          WtTile(child :col="4").no-padding.pr-2
            BField(label="Start Date")
              BDatepicker(
                :min-date="programStartDate"
                :max-date="new Date()"
                icon="calendar-today"
                editable
                v-model="programChallengeStartDate"
                :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                :events="startDatePickerEvents"
                position="is-top-right"
              )

          WtTile(child :col="4").no-padding.pr-2
            BField(label="End Date").no-padding
              BDatepicker(
                icon="calendar-today"
                editable
                v-model="programChallengeEndDate"
                :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                :min-date="programChallengeStartDate ? programChallengeStartDate : programStartDate"
                :max-date="new Date()"
                :events="endDatePickerEvents"
                position="is-top-right"
              )

          WtTile(child :col="4").no-padding
            BField(:message="completeChallengeStatsReportEmailSent ? 'Email Sent' : ''")
              WtButton(
                color="primary"
                class="download-btn"
                :loading="processingCompleteChallengeDownload"
                @click.native="downloadChallengeCompletionReport"
              ).mt-5 DOWNLOAD

  WtTile(parent :col="12").challenge-report-card
    #loader(v-if="showSpinner")
      BLoading(
        :active.sync="showSpinner"
        :is-full-page="false"
      )
        //- note, WtTile employs the same template as this
        .is-syncing-loader.has-text-weight-bold.is-size-1 Syncing..

    WtTile(child :col="6" child-class="no-padding")
      BAutocomplete.autocomplete(
        id="challenge"
        :data="filteredChallenges"
        v-model="selectedChallenge"
        :open-on-focus="true"
        :clearable="true"
        :custom-formatter="challenge => formatChallengeName(challenge)"
        placeholder="Select challenge..."
        dropdown-position="bottom"
        :icon="selectedChallengeIsFeatured ? 'star' : ''"
        @select="value => handleChallengeSelect(value)"
      )
        template(slot-scope="props")
          .media
            BIcon.dropdown-star-icon(icon="star" v-if="props.option.featured")
            .media-content
              .content
                div.ellipsis {{formatChallengeName(props.option)}}

    WtTile(child :col="1" v-if="challengeData" child-class="no-padding")
      RouterLink.button.is-text.is-small(
        :to="{ path: '/challenges/'+challengeId}"
      ) &nbsp;View Challenge

    WtTile(child :col="5" v-if="challengeData" child-class="no-padding")
      WtButton(
        v-if="challengeData"
        @click.native="downloadChallengeStatsReport"
        :loading="processingDownload"
        :disabled="downloadIsBeingEmailed.includes(this.challengeId)"
      ).is-pulled-right.ml-1.mb-1 {{ downloadIsBeingEmailed.includes(this.challengeId) ? 'Report Sent To Email' : 'Download Complete Report' }}

      WtButton(
        v-if="!_.get(challenge, 'isPvsPChallenge', false) && $auth.user().isWtAdmin && challengeData && challengeData.isBetweenTeams && challenge && challenge.isCompleted"
        @click.native="downloadTeamWinnerList"
        :loading="processingWinnersDownload"
      ).is-pulled-right {{ downloadIsBeingEmailed.includes(this.challengeId + '-winners') ? 'Report Sent To Email' : 'Download Team Winner List' }}
  template(v-if="!_.get(challenge, 'isPvsPChallenge', false)").challenge-report-card
    // TODO PvsP challengeData
    span(v-if="challengeData")
      WtTile(parent :col="12")
        WtTitle(h5) Challenge Details

      WtTile(parent :col="12")
        WtTile(child :col="2" child-class="no-padding")
          small Start Date
          p {{ challengeData.startDate }}

        WtTile(child :col="2" child-class="no-padding")
          small End Date
          p {{ challengeData.endDate }}

        WtTile(child :col="2" child-class="no-padding")
          small Between
          p(v-if="challengeData.isBetweenTeams") Teams
          p(v-if="challengeData.isBetweenIndividuals") Individuals

      WtTile(parent :col="12" child-class="no-padding").background-grey
        WtTile(parent :col="3" v-if="challengeData.isBetweenIndividuals")
          WtTile(child :col="12" child-class="no-padding")
            .card
              .card-content
                WtTitle(h5) Total Participants
                .is-size-1 {{ formatWithCommas(challengeData.totalParticipants) }}
                small Last user joined {{ challengeData.lastUserJoinedDate }}
        WtTile(parent :col="3" v-if="challengeData.isBetweenTeams")
          WtTile(child :col="12" child-class="no-padding")
            .card
              .card-content
                WtTitle(h5) Teams&nbsp;
                  small.is-blue (total)
                .is-size-1 {{ formatWithCommas(challengeData.totalTeams) }}
                small {{ challengeData.totalParticipants }} Participants

        WtTile(parent :col="3" v-if="challenge.isWellness")
          WtTile(child :col="12" child-class="no-padding")
            .card
              .card-content
                WtTitle(h5) Total Entries
                .is-size-1 {{ formatWithCommas(challengeData.totalWellnessEntries) }}

        WtTile(parent :col="3" v-if="challenge.isWellness")
          WtTile(child :col="12" child-class="no-padding")
            .card
              .card-content
                WtTitle(h5) Total Points
                .is-size-1 {{ formatWithCommas(challengeData.totalWellnessPoints) }}

        WtTile(parent :col="3" v-if="!challenge.isWellness")
          WtTile(child :col="12" child-class="no-padding")
            .card
              .card-content
                WtTitle(h5) {{activityText()}} Per Day&nbsp;
                  small.is-grey (avg)
                .is-size-1 {{ formatWithCommas( activityAverageValue() ) }}

        WtTile(parent :col="3" v-if="!challenge.isWellness")
          WtTile(child :col="12" child-class="no-padding")
            .card
              .card-content
                WtTitle(h5) Total {{activityText()}}&nbsp;
                .is-size-1 {{ formatWithCommas( activityTotalValue() ) }}

        WtTile(parent :col="3" v-if="!challenge.isWellness")
          WtTile(child :col="12" child-class="no-padding")
            .card
              .card-content
                WtTitle(h5) {{programUnits(programSettingsCopy)}} Walked
                .is-size-1 {{ formatWithCommas(milesToProgramUnits(programSettingsCopy, challengeData.milesWalked)) }}
                small.is-grey {{ formatWithCommas(challengeData.totalCaloriesBurned)}} Calories Burned

      WtTile(parent :col="12")
        WtTile(child :col="4").has-text-centered
          WtTitle(h5).mb-5 {{challengeData.isBetweenTeams ? 'Teams' : 'Participants'}} Who Met Challenge Goal

          PieChart(
            :chart-data="participantsWhoMetChallengeGoal"
            showLegend=true
            legendPosition="bottom"
            :legendFontSize=12
          )

        WtTile(child :col="4")
          Top5Walkers(
            :title="`Leaderboard`"
            :data="top5WalkersChartData"
            :leaderboardTracking="challenge.isWellness ? 'points' : 'steps'"
            :leaderboardTrackingText="activityText()"
            :loaded-status="leaderboardLoaded"
          )
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { numberUtilityMixin } from "@/mixins/numberUtilityMixin";
import { unitSettingsMixin } from "@/mixins/unitSettingsMixin";
import WtTile from "@@/WtTile/WtTile";
import PieChart from "@/charts/PieChart";
import WtLeaderboard from "@@/WtLeaderboard/WtLeaderboard";
import Top5Walkers from "@@/WtLeaderboard/Top5Walkers";

const tangerine = "#FF521C";
const tangerine_light = "#FF9879";

export default {
  name: "ChallengeReports",

  components: {
    WtTile,
    WtTitle,
    WtButton,
    PieChart,
    WtLeaderboard,
    Top5Walkers
  },

  mixins: [dateUtilityMixin, numberUtilityMixin, unitSettingsMixin],

  props: {
    challenges: {
      type: Array,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      programChallengeStartDate: null,
      programChallengeEndDate: null,
      completeChallengeStatsReportEmailSent: false,
      challenge: null,
      challengeId: null,
      optionName: "",
      aggregate: {},
      processingDownload: false,
      processingWinnersDownload: false,
      processingCompleteChallengeDownload: false,
      selectedChallenge: null,
      selectedChallengeIsFeatured: false,
      challengeData: null,
      top5WalkersChartData: [],
      showSpinner: false,
      downloadIsBeingEmailed: [],
      selectChallengeError: false
    };
  },

  computed: {
    ...mapGetters("challenges", ["getAggregateById", "aggregateLoaded"]),
    ...mapGetters("program", [
      "leaderboardLoaded",
      "leaderboard",
      "programSettingsCopy",
      "coreProgramMeta"
    ]),

    startDatePickerEvents() {
      return this.endDate ? [this.endDate] : null;
    },

    endDatePickerEvents() {
      return this.startDate ? [this.startDate] : null;
    },

    programStartDate() {
      return new Date(
        new Date(this.coreProgramMeta.startDate).setHours(0, 0, 0, 0)
      );
    },

    filteredChallenges() {
      if (this.selectedChallenge) {
        return this.challenges.filter(option => {
          return (
            option.name
              .toString()
              .toLowerCase()
              .indexOf(this.selectedChallenge.toLowerCase()) >= 0
          );
        });
      } else {
        return this.challenges;
      }
    },

    determineActivityText() {
      let text = "";
      if (this.challenge.allowActivities == 0) {
        text = "Steps";
      }
      if (this.challenge.allowActivities == 1) {
        text = "Steps & Activities";
      }
      if (this.challenge.allowActivities == 2) {
        text = "Activities";
      }
      return text;
    },

    determineActivityTotalValue() {
      let value = 0;
      if (this.challenge.allowActivities == 0) {
        value = this.challengeData.totalSteps;
      }
      if (this.challenge.allowActivities == 1) {
        value = this.challengeData.stepsAndActivities;
      }
      if (this.challenge.allowActivities == 2) {
        value = this.challengeData.totalActivities;
      }
      return value;
    },

    determineActivityAverageValue() {
      let value = 0;
      if (this.challenge.allowActivities == 0) {
        value = this.challengeData.averageSteps;
      }
      if (this.challenge.allowActivities == 1) {
        value = this.challengeData.averageStepsAndActivities;
      }
      if (this.challenge.allowActivities == 2) {
        value = this.challengeData.averageActivities;
      }
      return value;
    },

    participantsWhoMetChallengeGoal() {
      const labels = ["Met Challenge Goal", "Didn't Meet Challenge Goal"];
      const totalParticipants = this.challengeData.isBetweenTeams
        ? this.challengeData.totalTeams
        : this.challengeData.totalParticipants;
      const notMetGoal =
        totalParticipants - this.challengeData.totalParticipantsMetGoal;
      const metGoal = this.challengeData.totalParticipantsMetGoal;
      const datasets = [
        {
          backgroundColor: [tangerine, tangerine_light],
          data: [metGoal, notMetGoal]
        }
      ];

      return { labels, datasets };
    }
  },

  methods: {
    ...mapActions("challenges", [
      "fetchChallenge",
      "challengeStatsDownload",
      "fetchChallengeAggregate",
      "fetchLeaderboard",
      "teamChallengeWinnersDownload",
      "completeChallengeStatsDownload"
    ]),
    ...mapActions(["snackBar"]),

    async getTop5WalkersChartData(challengeId) {
      let response = await this.fetchLeaderboard({ challengeId, perPage: 5 });
      this.top5WalkersChartData = response.data.filter(el => el.position <= 5);
    },

    handleChallengeSelect(item) {
      if (item) {
        this.selectChallenge(item);
        this.selectedChallengeIsFeatured = item.featured;
      }
    },

    async selectChallenge(challenge) {
      this.showSpinner = true;
      this.challengeId = challenge.id;
      try {
        this.challenge = await this.fetchChallenge(this.challengeId);
        let result = await this.fetchChallengeAggregate(this.challengeId);
        this.challengeData = result.data.data;

        await this.getTop5WalkersChartData(this.challengeId);
      } catch (error) {
        console.log("selectChallenge -> error", error);
        this.selectChallengeError = true;
      }

      this.showSpinner = false;
    },

    formatChallengeName(challenge) {
      const statusArray = ["Pending", "Active", "Completed"];
      let formattedName = `${challenge.name} | `;
      if (challenge.featured) {
        formattedName = `Featured: ${formattedName}`;
      }
      let startDate = this.moment(challenge.startDate).format("MMM DD, YYYY");
      let endDate = this.moment(challenge.endDate).format("MMM DD, YYYY");
      formattedName += `${startDate} - ${endDate} | ${
        statusArray[challenge.status]
      }`;
      return formattedName;
    },

    activityText() {
      return this.determineActivityText;
    },

    activityTotalValue() {
      return this.determineActivityTotalValue;
    },

    activityAverageValue() {
      return this.determineActivityAverageValue;
    },

    async downloadChallengeStatsReport() {
      this.processingDownload = true;

      let response = await this.challengeStatsDownload(this.challengeId);

      if (
        !this._.has(response, "data") ||
        this._.has(response, "data.error.message")
      ) {
        this.snackBar({
          duration: 10000,
          type: "is-danger",
          message: this._.get(
            response,
            "data.error.message",
            `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
          )
        });
      }

      if (this._.has(response, "data")) {
        this.downloadIsBeingEmailed.push(this.challengeId);
        this.snackBar({
          type: "is-info",
          message: `The report is processing and will be sent to ${
            this.$auth.user().email
          }.  Please check there in a few minutes.`
        });
      }

      this.processingDownload = false;
    },

    downloadChallengeCompletionReport() {
      this.processingCompleteChallengeDownload = true;

      const payload = {
        programId: this.coreProgramMeta.id,
        startDate: this.programChallengeStartDate
          ? this.formatDateForRequest(this.programChallengeStartDate)
          : this.coreProgramMeta.startDate,
        endDate: this.programChallengeEndDate
          ? this.formatDateForRequest(this.programChallengeEndDate)
          : this.today().formatted
      };

      this.completeChallengeStatsReportEmailSent = false;

      this.completeChallengeStatsDownload(payload)
        .then(response => {
          if (
            !this._.has(response, "data") ||
            this._.has(response, "data.error.message")
          ) {
            this.snackBar({
              duration: 10000,
              type: "is-danger",
              message: this._.get(
                response,
                "data.error.message",
                `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
              )
            });
            return;
          }

          let jsonResponse = false;
          try {
            jsonResponse = JSON.parse(
              new TextDecoder().decode(new Uint8Array(response.data))
            );
          } catch (e) {
            jsonResponse = false; // It's a CSV or binary file
          }

          if (
            this._.get(jsonResponse, "data.message", false) === "sent_to_email"
          ) {
            this.snackBar({
              type: "is-info",
              message: `The report is processing and will be sent to ${
                this.$auth.user().email
              }. Please check there in a few minutes.`
            });
            this.challengeCompleteReportEmailSent = true;
          } else if (this._.has(response, "data")) {
            const mimeType =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const blob = new Blob([response.data], { type: mimeType });
            const downloadUrl = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.download = `program_challenges_completion_stats_${payload.startDate}_to_${payload.endDate}.xlsx`;
            a.href = downloadUrl;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a); // Cleanup
            URL.revokeObjectURL(downloadUrl); // Cleanup URL
          }
        })
        .catch(error => {
          console.error("Error downloading report:", error);
          this.snackBar({
            duration: 10000,
            type: "is-danger",
            message:
              "An unexpected error occurred while downloading the report."
          });
        })
        .finally(() => {
          this.processingCompleteChallengeDownload = false;
        });
    },

    async downloadTeamWinnerList() {
      this.processingWinnersDownload = true;

      let response = await this.teamChallengeWinnersDownload(this.challengeId);

      if (
        !this._.has(response, "data") ||
        this._.has(response, "data.error.message")
      ) {
        this.snackBar({
          duration: 10000,
          type: "is-danger",
          message: this._.get(
            response,
            "data.error.message",
            `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
          )
        });
      } else if (this._.has(response, "data")) {
        this.downloadIsBeingEmailed.push(this.challengeId + "-winners");
        this.snackBar({
          type: "is-info",
          message: `The report is processing and will be sent to ${
            this.$auth.user().email
          }.  Please check there in a few minutes.`
        });
      }

      this.processingWinnersDownload = false;
    },

    challengeLabel(challenge) {
      return `${challenge.name}: (${
        this.date(challenge.startDate, "DATE_FORMAT_SLASH").formatted
      } - ${this.date(challenge.endDate, "DATE_FORMAT_SLASH").formatted})`;
    }
  }
};
</script>

<style lang="sass" scoped>
#challenge-reports
  .title
    margin-bottom: 0px
  small
    color: $grey
    font-size: 12px
  .is-grey
    color: $grey
  .no-padding
    padding: 0px
  .mt-5
    margin-top: 31px !important
  .card
    background-color: $grey-lighter !important
    height: 150px
    overflow: visible

  .dropdown-star-icon
    margin-left: -5px
  .media-content
    max-width: 100%
  .ellipsis
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
  .ellipsis:hover
    text-overflow: clip
    white-space: normal
    word-break: break-all
  .reportTile
    background-color: $grey-lighter
    .wt-tile
      background-color: $grey-lighter
</style>
